export default __webpack_public_path__ + "static/media/mobileDevelopment.1e7d9b1a.png";